var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel granary-panel" }, [
    _c(
      "div",
      { staticClass: "type-box" },
      _vm._l(_vm.proType, function (it, i) {
        return _c(
          "div",
          {
            key: i,
            staticClass: "pro-item",
            class: { proActive: _vm.proActive === it.code },
            on: {
              click: function ($event) {
                return _vm.changeProType(it.code)
              },
            },
          },
          [_vm._v(" " + _vm._s(it.name) + " ")]
        )
      }),
      0
    ),
    _c("div", { staticClass: "chart-box" }, [
      _c(
        "div",
        { staticClass: "tab-box flex" },
        _vm._l(_vm.typeList, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "tab-item",
              class: { active: _vm.active === index },
              on: {
                click: function ($event) {
                  return _vm.changeType(index)
                },
              },
            },
            [_c("span", [_vm._v(_vm._s(item))])]
          )
        }),
        0
      ),
      _c("div", { ref: "chart", staticClass: "chart" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }